import { Minus, Plus } from 'lucide-react';

type Props = {
  zoom: number;
  canZoomOut: boolean;
  canZoomIn: boolean;
  onZoomOut: () => void;
  onZoomIn: () => void;
  onReset: () => void;
};

const ICON_BUTTON =
  'rounded-full p-1 hover:bg-muted disabled:opacity-40 disabled:hover:bg-transparent';

/** 사진 박스 오른쪽 위에 떠 있는 확대·축소 컨트롤. 100% 가 화면에 맞춤 크기다. */
export function ZoomControl({ zoom, canZoomOut, canZoomIn, onZoomOut, onZoomIn, onReset }: Props) {
  return (
    <div className="absolute right-3 top-3 z-10 flex items-center gap-1 rounded-full border bg-background px-2 py-1 text-sm shadow-sm">
      <span className="min-w-10 text-center tabular-nums">{zoom}%</span>
      <button
        type="button"
        aria-label="축소"
        disabled={!canZoomOut}
        onClick={onZoomOut}
        className={ICON_BUTTON}
      >
        <Minus className="size-4" aria-hidden />
      </button>
      <button
        type="button"
        aria-label="확대"
        disabled={!canZoomIn}
        onClick={onZoomIn}
        className={ICON_BUTTON}
      >
        <Plus className="size-4" aria-hidden />
      </button>
      <button
        type="button"
        disabled={zoom === 100}
        onClick={onReset}
        className="rounded-full px-2 py-0.5 hover:bg-muted disabled:opacity-40 disabled:hover:bg-transparent"
      >
        초기화
      </button>
    </div>
  );
}
